/*
* Helper functions for quickview
*/

/**
 * Update product URL based on current selected product
 * @param {Object} product Product Object
 * @param {jQuery} $container jQuery selector
 */
function updateProductURL(product, $container) {
    var viewDetailsLinkLabel = $('.viewdetails-link-label').val();
    var productUrl = product.pdpurl ? product.pdpurl : product.selectedProductUrl;
    if ($container) {
        var $link = $('<a>', {
            class: 'ds-btn-block secondary',
            target: '_self',
            href: encodeURI(productUrl || ''),
            text: viewDetailsLinkLabel
        });

        $container.find('.viewdetails-link').html($link);
        $container.find('.viewdetails-link').attr('data-selectedproducturl', product.selectedProductUrl);
    }
}

/**
 * @param {jQuery} $element DOM element
 * @param {Object} attrValue - Attribute Values
 * @param {Object} attr attribute list
 * @param {string}  quickViewContainerId - DOM element id for quick view container
 */
function updateAttributeDisplay($element, attrValue, attr, quickViewContainerId) {
    const isSelected = attrValue.selected;
    // eslint-disable-next-line no-unneeded-ternary
    const quickViewContainerIdCopy = quickViewContainerId ? quickViewContainerId : '';

    $element.attr('aria-checked', isSelected);
    $element.attr('data-url', attrValue.url || '');

    if (isSelected) {
        $(quickViewContainerIdCopy + ' h3.' + attr.id).html(
            `<span class="variation__attr--name">${attr.displayName}</span><span class="variation__attr--value">${attr.displayValue}</span>`
        );
    }
}

/**
 * Process attribute values in QBB associated with an attribute that does not have image swatches
 * @param {Object} attr - Attribute
 * @param {boolean} isGrouped - check if grouped
 */
function renderSwatchValuesQBB(attr, isGrouped) {
    const values = isGrouped ? attr.values.flatMap(group => group.values) : attr.values;

    values.forEach((attrValue) => {
        const $quickAttrValue = $(`.${attr.id}quick-${attrValue.value}`);
        $quickAttrValue.attr('aria-checked', attrValue.selected ? 'true' : 'false');
        $quickAttrValue.closest('li').toggleClass('colorOOS', !attrValue.selectable);
        updateAttributeDisplay($quickAttrValue, attrValue, attr);
    });
}

/**
 * Process attribute values in QBB associated with an attribute that does not have image swatches
 * @param {Object} attr - Attribute
 * @param {string} quickViewContainerId - ID of quick view container
 * @param {boolean} isGrouped - check if grouped
 */
function processAttributeValues(attr, quickViewContainerId, isGrouped) {
    const baseSelector = quickViewContainerId ? `${quickViewContainerId} #` : '#';
    const values = isGrouped ? attr.values.flatMap(group => group.values) : attr.values;

    values.forEach((attrValue) => {
        const attrId = `${attr.id}item-${attrValue.value}`;
        const $attrValue = $(`${baseSelector}${attrId}`);

        updateAttributeDisplay($attrValue, attrValue, attr, quickViewContainerId);

        $attrValue.toggleClass('colorOOS', !attrValue.selectable);
        // eslint-disable-next-line no-unneeded-ternary
        const quickViewContainerIdCopy = quickViewContainerId ? quickViewContainerId : '';
        if (!$attrValue.length && attrValue.selectable) {
            let $floatingBucket = $(quickViewContainerIdCopy + ' .js-floatingColorList');
            if ($floatingBucket.length) {
                var swatchValues = `<li id="${attr.id}item-${attrValue.value}"
                                    class='variant-list__item variant-color-item variant-${attr.id}' role='radio' aria-labelledby="color_S_Label"
                                    data-attr-value="${attrValue.value}" data-display-id='${attr.id}' data-url="${attrValue.url}"
                                    tabindex="0" style="background-image: url(${attrValue.images.swatch.length !== 0 ? attrValue.images.swatch[0].url : ''})">
                                </li>`;
                $floatingBucket.removeClass('d-none').append(swatchValues);
            }
        }
    });
}

/**
 * Process attribute values in QBB associated with an attribute that does not have image swatches
 * @param {Object} attr - Attribute object
 * @param {boolean} strikeThroughStatus - Having strikeThroughStatus true or false
 * @param {string} quickViewContainerId - ID of quick view container
 * @param {boolean} isTeaser - check if teaser
 */
function processSwatchValues(attr, strikeThroughStatus, quickViewContainerId, isTeaser = false) {
    const isGrouped = attr.isGroupedByPrice;
    // eslint-disable-next-line no-unneeded-ternary
    const quickViewContainerIdCopy = quickViewContainerId ? quickViewContainerId : '';
    if ($(`${quickViewContainerIdCopy} .quickbuy--variant-selector-container`).length) {
        renderSwatchValuesQBB(attr, isGrouped);
    } else {
        processAttributeValues(attr, quickViewContainerIdCopy, isGrouped, strikeThroughStatus, isTeaser);
    }

    var $colorLists = $('.variation-spacing-colorCode .variant-list');
    $colorLists.each(function () {
        let $elem = $(this);
        let $visibleColorSwatch = $elem.find('.variant-list__item:not(.colorOOS)');
        if (!$visibleColorSwatch.length) {
            $elem.addClass('d-none');
            $elem.prev().addClass('d-none');
        } else {
            $elem.removeClass('d-none');
            $elem.prev().removeClass('d-none');
        }
    });
}


module.exports = {
    updateProductURL: updateProductURL,
    processSwatchValues: processSwatchValues
};
